<template>
    <div v-if="!!error" class="notification is-danger is-light">
        <p><b>Something went wrong!</b></p>
        <p>{{ error }}</p>
    </div>
    <div v-if="currentFD.deliveries_generated && currentFD.status == 'DRAFT'" class="block">
        <div v-if="currentFD.teams_driving">
            <div v-if="currentFD.deliveries_assigned_to_teams" class="notification is-info">
                Deliveries assigned to the teams.</div>
            <div v-else class="align-center">
                <button :class="[isLoading ? 'is-loading' : '']" class="button is-rounded is-info"
                    @click="assignDeliveries">
                    Assign Deliveries to Teams</button>
            </div>
        </div>
        <div v-else class="notification">
            <p>Deliveries generated.</p>
            <p>Teams are <i>not</i> created yet.</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            error: ""
        }
    },
    methods: {
        async assignDeliveries() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('delivery/assignDeliveriesToTeams', {
                    fdID: this.currentFD.id,
                    countDrivingTeams: this.currentFD.teams_driving,
                    countWalkingTeams: this.currentFD.teams_walking
                });
            } catch (error) {
                console.log(error);
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
            this.isSuccess = true;
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        }
    }
}
</script>